// import React, { useState, useEffect, useCallback } from "react";
// import { toast } from "react-toastify";
// import { 
//   Calendar, Clock, X, Plus, AlertCircle
// } from "lucide-react";
// import api from "../../common/apiClient";
// import SummaryApi from "../../common/SummaryApi";
// import PageLoader from "../../helpers/PageLoader";

// export default function MyPermissionsAndCompOffs() {
//   const [loading, setLoading] = useState(true);
//   const [activeTab, setActiveStageTab] = useState("permissions");

//   // Lists Data
//   const [permissions, setPermissions] = useState([]);
//   const [compOffs, setCompOffs] = useState([]);

//   // Modal Open States
//   const [showPermissionModal, setShowPermissionModal] = useState(false);
//   const [showCompOffModal, setShowCompOffModal] = useState(false);

//   // Form Submission Loader
//   const [submitting, setSubmitting] = useState(false);

//   // Form States
//   const [permissionForm, setPermissionForm] = useState({
//     date: "",
//     startTime: "",
//     endTime: "",
//     reason: ""
//   });

//   const [compOffForm, setCompOffForm] = useState({
//     workedDate: "",
//     reason: ""
//   });

//   // Inline Validation Errors States (புதிதாக சேர்க்கப்பட்டது)
//   const [permissionErrors, setPermissionErrors] = useState({});
//   const [compOffErrors, setCompOffErrors] = useState({});

//   // ── DATA FETCHING ─────────────────────────────────────────────────────────
//   const fetchMyData = useCallback(async () => {
//     setLoading(true);
//     try {
//       const permUrl = SummaryApi.myPermissions?.url || "/api/hr/permission/my";
//       const compUrl = SummaryApi.myCompOffs?.url || "/api/hr/compoff/my";

//       const [permRes, compRes] = await Promise.all([
//         api.get(permUrl),
//         api.get(compUrl)
//       ]);

//       if (permRes.data.success) setPermissions(permRes.data.data || []);
//       if (compRes.data.success) setCompOffs(compRes.data.data || []);

//     } catch (err) {
//       toast.error(err.response?.data?.message || "Failed to load request records.");
//     } finally {
//       setLoading(false);
//     }
//   }, []);

//   useEffect(() => {
//     fetchMyData();
//   }, [fetchMyData]);

//   // ── FRONTEND VALIDATIONS (புதிதாக சேர்க்கப்பட்டது) ─────────────────────────
//   const validatePermissionForm = () => {
//     const errors = {};
//     if (!permissionForm.date) {
//       errors.date = "Permission date is required.";
//     }
//     if (!permissionForm.startTime) {
//       errors.startTime = "Start time is required.";
//     }
//     if (!permissionForm.endTime) {
//       errors.endTime = "End time is required.";
//     }

//     if (permissionForm.startTime && permissionForm.endTime) {
//       const [startH, startM] = permissionForm.startTime.split(':').map(Number);
//       const [endH, endM] = permissionForm.endTime.split(':').map(Number);
//       const startTotal = startH * 60 + startM;
//       const endTotal = endH * 60 + endM;

//       if (endTotal <= startTotal) {
//         errors.endTime = "End time must be after the start time.";
//       } else if (endTotal - startTotal > 120) {
//         errors.endTime = "A single permission duration cannot exceed 2 hours (120 mins).";
//       }
//     }

//     if (!permissionForm.reason || permissionForm.reason.trim().length < 5) {
//       errors.reason = "Please provide a valid reason (at least 5 characters).";
//     }

//     setPermissionErrors(errors);
//     return Object.keys(errors).length === 0;
//   };

//   const validateCompOffForm = () => {
//     const errors = {};
//     if (!compOffForm.workedDate) {
//       errors.workedDate = "Worked date is required.";
//     } else {
//       const selectedDate = new Date(compOffForm.workedDate);
//       const today = new Date();
//       today.setHours(23, 59, 59, 999); // இன்றைய நாளின் இறுதி நேரம்

//       if (selectedDate > today) {
//         errors.workedDate = "Worked date cannot be a future date.";
//       }
//     }

//     if (!compOffForm.reason || compOffForm.reason.trim().length < 10) {
//       errors.reason = "Please describe the work done in detail (at least 10 characters).";
//     }

//     setCompOffErrors(errors);
//     return Object.keys(errors).length === 0;
//   };

//   // ── FORM SUBMISSIONS ──────────────────────────────────────────────────────
//   const handlePermissionSubmit = async (e) => {
//     e.preventDefault();
//     if (!validatePermissionForm()) return; // Validation தோல்வியடைந்தால் சப்மிட் ஆகாது

//     setSubmitting(true);
//     try {
//       const url = SummaryApi.requestPermission?.url || "/api/hr/permission/create";
//       const res = await api.post(url, permissionForm);

//       if (res.data.success) {
//         toast.success(res.data.message || "Permission request submitted.");
//         setShowPermissionModal(false);
//         setPermissionForm({ date: "", startTime: "", endTime: "", reason: "" });
//         setPermissionErrors({});
//         fetchMyData();
//       }
//     } catch (err) {
//       toast.error(err.response?.data?.message || "Failed to request permission.");
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   const handleCompOffSubmit = async (e) => {
//     e.preventDefault();
//     if (!validateCompOffForm()) return; // Validation தோல்வியடைந்தால் சப்மிட் ஆகாது

//     setSubmitting(true);
//     try {
//       const url = SummaryApi.requestCompOff?.url || "/api/hr/compoff/create";
//       const res = await api.post(url, compOffForm);

//       if (res.data.success) {
//         toast.success(res.data.message || "Comp-off earning request submitted.");
//         setShowCompOffModal(false);
//         setCompOffForm({ workedDate: "", reason: "" });
//         setCompOffErrors({});
//         fetchMyData();
//       }
//     } catch (err) {
//       toast.error(err.response?.data?.message || "Failed to request Comp-off grant.");
//     } finally {
//       setSubmitting(false);
//     }
//   };

//   if (loading) return <PageLoader />;

//   return (
//     <div className="space-y-6 animate-in fade-in duration-300">
      
//       {/* HEADER WITH ACTION BUTTONS */}
//       <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 bg-white border p-6 rounded-xl shadow-sm">
//         <div>
//           <h1 className="text-xl font-bold text-slate-900 tracking-tight">Permissions & Comp-offs</h1>
//           <p className="text-xs text-slate-400 mt-1">Submit or track your short permissions and compensatory off grant requests.</p>
//         </div>
//         <div className="flex flex-wrap gap-2 shrink-0">
//           <button
//             onClick={() => {
//               setPermissionErrors({});
//               setShowPermissionModal(true);
//             }}
//             className="inline-flex items-center gap-1.5 bg-primary hover:bg-secondary text-white text-xs font-bold px-4 py-2 rounded-lg transition-all shadow-sm"
//           >
//             <Plus className="w-4 h-4" />
//             <span>Apply Permission</span>
//           </button>
//           <button
//             onClick={() => {
//               setCompOffErrors({});
//               setShowCompOffModal(true);
//             }}
//             className="inline-flex items-center gap-1.5 bg-secondary hover:bg-primary text-white text-xs font-bold px-4 py-2 rounded-lg transition-all shadow-sm"
//           >
//             <Plus className="w-4 h-4" />
//             <span>Apply Comp-off</span>
//           </button>
//         </div>
//       </div>

//       {/* TABS CONTAINER */}
//       <div className="overflow-hidden flex flex-col">
//         {/* Navigation Tabs */}
//         <div className="flex border-b">
//           <button
//             onClick={() => setActiveStageTab("permissions")}
//             className={`flex-1 py-4 text-center text-xs font-bold uppercase tracking-wider border-b-2 transition-all ${
//               activeTab === "permissions" 
//                 ? "border-red-600 text-red-600 bg-red-50/10" 
//                 : "border-transparent text-slate-500 hover:text-secondary hover:bg-slate-50/50"
//             }`}
//           >
//             Hourly Permissions ({permissions.length})
//           </button>
//           <button
//             onClick={() => setActiveStageTab("compoffs")}
//             className={`flex-1 py-4 text-center text-xs font-bold uppercase tracking-wider border-b-2 transition-all ${
//               activeTab === "compoffs" 
//                 ? "border-red-600 text-red-600 bg-red-50/10" 
//                 : "border-transparent text-slate-500 hover:text-secondary hover:bg-slate-50/50"
//             }`}
//           >
//             Comp-off Grants ({compOffs.length})
//           </button>
//         </div>

//         {/* LIST TABLE CONTENT */}
//         <div className="p-4 sm:p-6 overflow-x-auto">
//           {activeTab === "permissions" ? (
//             permissions.length === 0 ? (
//               <div className="text-center py-16 text-slate-400 text-xs font-medium">
//                 No hourly permission requests submitted yet.
//               </div>
//             ) : (
//               <table className="w-full text-left border-collapse text-xs">
//                 <thead>
//                   <tr className="bg-slate-50 border-b text-[10px] font-bold text-slate-400 uppercase tracking-wider">
//                     <th className="py-3 px-4">Requested Date</th>
//                     <th className="py-3 px-4">Time Interval</th>
//                     <th className="py-3 px-4">Duration</th>
//                     <th className="py-3 px-4">Reason</th>
//                     <th className="py-3 px-4">Status</th>
//                     <th className="py-3 px-4">Approver Note</th>
//                   </tr>
//                 </thead>
//                 <tbody className="divide-y text-slate-700">
//                   {permissions.map((p) => (
//                     <tr key={p._id} className="hover:bg-slate-50/40 transition-colors">
//                       <td className="py-3 px-4 font-bold text-slate-900">{new Date(p.date).toLocaleDateString()}</td>
//                       <td className="py-3 px-4 font-semibold text-slate-600">{p.startTime} - {p.endTime}</td>
//                       <td className="py-3 px-4 font-medium text-slate-500">{p.durationMinutes} Minutes</td>
//                       <td className="py-3 px-4 italic max-w-xs truncate">"{p.reason || "N/A"}"</td>
//                       <td className="py-3 px-4">
//                         <span className={`text-[9px] font-bold px-2 py-0.5 rounded-full border uppercase tracking-wider ${
//                           p.status === "approved" 
//                             ? "bg-green-50 text-green-700 border-green-200" 
//                             : p.status === "pending"
//                             ? "bg-amber-50 text-amber-700 border-amber-200"
//                             : "bg-red-50 text-red-700 border-red-200"
//                         }`}>
//                           {p.status}
//                         </span>
//                       </td>
//                       <td className="py-3 px-4 text-slate-400 italic">
//                         {p.approverNote ? `"${p.approverNote}"` : "-"}
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             )
//           ) : (
//             compOffs.length === 0 ? (
//               <div className="text-center py-16 text-slate-400 text-xs font-medium">
//                 No compensatory off requests submitted yet.
//               </div>
//             ) : (
//               <table className="w-full text-left border-collapse text-xs">
//                 <thead>
//                   <tr className="bg-slate-50 border-b text-[10px] font-bold text-slate-400 uppercase tracking-wider">
//                     <th className="py-3 px-4">Worked Date</th>
//                     <th className="py-3 px-4">Earning Reason</th>
//                     <th className="py-3 px-4">Expiry Date</th>
//                     <th className="py-3 px-4">Status</th>
//                     <th className="py-3 px-4">Approver Note</th>
//                   </tr>
//                 </thead>
//                 <tbody className="divide-y text-slate-700">
//                   {compOffs.map((c) => (
//                     <tr key={c._id} className="hover:bg-slate-50/40 transition-colors">
//                       <td className="py-3 px-4 font-bold text-slate-900">{new Date(c.workedDate).toLocaleDateString()}</td>
//                       <td className="py-3 px-4 font-medium text-slate-600">"{c.reason}"</td>
//                       <td className="py-3 px-4 text-slate-500 font-semibold">
//                         {c.expiryDate ? new Date(c.expiryDate).toLocaleDateString() : "Pending approval"}
//                       </td>
//                       <td className="py-3 px-4">
//                         <span className={`text-[9px] font-bold px-2 py-0.5 rounded-full border uppercase tracking-wider ${
//                           c.status === "approved" 
//                             ? "bg-green-50 text-green-700 border-green-200" 
//                             : c.status === "pending"
//                             ? "bg-amber-50 text-amber-700 border-amber-200"
//                             : "bg-red-50 text-red-700 border-red-200"
//                         }`}>
//                           {c.status}
//                         </span>
//                       </td>
//                       <td className="py-3 px-4 text-slate-400 italic">
//                         {c.approverNote ? `"${c.approverNote}"` : "-"}
//                       </td>
//                     </tr>
//                   ))}
//                 </tbody>
//               </table>
//             )
//           )}
//         </div>
//       </div>

//       {/* APPLIED PERMISSION MODAL */}
//       {showPermissionModal && (
//         <div className="fixed inset-0 z-[1000] flex items-center justify-center p-3 sm:p-4 bg-black/50 backdrop-blur-sm animate-in fade-in duration-200">
//           <div className="bg-white w-full max-w-md rounded-xl shadow-xl border flex flex-col max-h-[90vh] sm:max-h-[85vh] overflow-hidden animate-in fade-in zoom-in-95 duration-200">
//             {/* Header */}
//             <div className="p-4 sm:p-5 border-b flex justify-between items-center shrink-0">
//               <div className="flex gap-3 items-center">
//                 <div className="w-10 h-10 rounded-full bg-red-50 text-primary flex items-center justify-center shrink-0 border border-red-100">
//                   <Clock className="w-5 h-5" />
//                 </div>
//                 <div>
//                   <h3 className="font-bold text-gray-900 text-sm sm:text-base leading-tight">Request Hourly Permission</h3>
//                   <p className="text-[10px] text-gray-400 font-bold uppercase mt-0.5">Short Duration Approval Request</p>
//                 </div>
//               </div>
//               <button onClick={() => setShowPermissionModal(false)} className="p-1.5 hover:bg-red-50 text-gray-400 hover:text-red-600 rounded-lg border transition-colors">
//                 <X className="w-4 h-4" />
//               </button>
//             </div>

//             {/* Form */}
//             <form onSubmit={handlePermissionSubmit} className="flex flex-col flex-1 overflow-hidden">
//               <div className="p-4 sm:p-6 space-y-4 overflow-y-auto flex-1 custom-scrollbar text-xs">
//                 {/* Date */}
//                 <div>
//                   <label className="block text-[10px] text-gray-400 font-bold uppercase mb-1">Permission Date</label>
//                   <input
//                     type="date"
//                     value={permissionForm.date}
//                     onChange={(e) => setPermissionForm(prev => ({ ...prev, date: e.target.value }))}
//                     className="w-full border rounded-lg px-3 py-2 border-slate-200 text-slate-700 font-medium focus:outline-none focus:ring-1 focus:ring-red-200"
//                   />
//                   {permissionErrors.date && (
//                     <p className="text-red-500 text-[10px] font-bold mt-1 flex items-center gap-1">
//                       <AlertCircle className="w-3.5 h-3.5" /> {permissionErrors.date}
//                     </p>
//                   )}
//                 </div>

//                 {/* Times */}
//                 <div className="grid grid-cols-2 gap-4">
//                   <div>
//                     <label className="block text-[10px] text-gray-400 font-bold uppercase mb-1">Start Time</label>
//                     <input
//                       type="time"
//                       value={permissionForm.startTime}
//                       onChange={(e) => setPermissionForm(prev => ({ ...prev, startTime: e.target.value }))}
//                       className="w-full border rounded-lg px-3 py-2 border-slate-200 text-slate-700 font-medium focus:outline-none focus:ring-1 focus:ring-red-200"
//                     />
//                     {permissionErrors.startTime && (
//                       <p className="text-red-500 text-[10px] font-bold mt-1 flex items-center gap-1">
//                         <AlertCircle className="w-3.5 h-3.5" /> {permissionErrors.startTime}
//                       </p>
//                     )}
//                   </div>
//                   <div>
//                     <label className="block text-[10px] text-gray-400 font-bold uppercase mb-1">End Time</label>
//                     <input
//                       type="time"
//                       value={permissionForm.endTime}
//                       onChange={(e) => setPermissionForm(prev => ({ ...prev, endTime: e.target.value }))}
//                       className="w-full border rounded-lg px-3 py-2 border-slate-200 text-slate-700 font-medium focus:outline-none focus:ring-1 focus:ring-red-200"
//                     />
//                     {permissionErrors.endTime && (
//                       <p className="text-red-500 text-[10px] font-bold mt-1 flex items-center gap-1">
//                         <AlertCircle className="w-3.5 h-3.5" /> {permissionErrors.endTime}
//                       </p>
//                     )}
//                   </div>
//                 </div>

//                 {/* Reason */}
//                 <div>
//                   <label className="block text-[10px] text-gray-400 font-bold uppercase mb-1">Reason</label>
//                   <textarea
//                     rows={3}
//                     placeholder="Provide a valid reason for this permission request..."
//                     value={permissionForm.reason}
//                     onChange={(e) => setPermissionForm(prev => ({ ...prev, reason: e.target.value }))}
//                     className="w-full border rounded-lg px-3 py-2 border-slate-200 text-slate-700 font-medium focus:outline-none focus:ring-1 focus:ring-red-200"
//                   />
//                   {permissionErrors.reason && (
//                     <p className="text-red-500 text-[10px] font-bold mt-1 flex items-center gap-1">
//                       <AlertCircle className="w-3.5 h-3.5" /> {permissionErrors.reason}
//                     </p>
//                   )}
//                 </div>
//               </div>

//               {/* Footer */}
//               <div className="p-3 sm:p-4 border-t bg-slate-50 flex justify-end gap-2 shrink-0">
//                 <button type="button" onClick={() => setShowPermissionModal(false)} className="px-4 py-2 bg-white text-slate-700 border rounded-lg text-xs font-bold uppercase hover:bg-slate-50 transition-colors">
//                   Cancel
//                 </button>
//                 <button type="submit" disabled={submitting} className="px-4 py-2 bg-primary hover:bg-secondary text-white rounded-lg text-xs font-bold uppercase transition-colors disabled:opacity-50">
//                   {submitting ? "Submitting..." : "Submit Request"}
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       )}

//       {/* COMP-OFF REQUEST MODAL */}
//       {showCompOffModal && (
//         <div className="fixed inset-0 z-[1000] flex items-center justify-center p-3 sm:p-4 bg-black/50 backdrop-blur-sm animate-in fade-in duration-200">
//           <div className="bg-white w-full max-w-md rounded-xl shadow-xl border flex flex-col max-h-[90vh] sm:max-h-[85vh] overflow-hidden animate-in fade-in zoom-in-95 duration-200">
//             {/* Header */}
//             <div className="p-4 sm:p-5 border-b flex justify-between items-center shrink-0">
//               <div className="flex gap-3 items-center">
//                 <div className="w-10 h-10 rounded-full bg-slate-50 text-slate-700 flex items-center justify-center shrink-0 border border-slate-100">
//                   <Calendar className="w-5 h-5" />
//                 </div>
//                 <div>
//                   <h3 className="font-bold text-gray-900 text-sm sm:text-base leading-tight">Request Comp-off Grant</h3>
//                   <p className="text-[10px] text-gray-400 font-bold uppercase mt-0.5">Credit Comp-off Day For Holiday Worked</p>
//                 </div>
//               </div>
//               <button onClick={() => setShowCompOffModal(false)} className="p-1.5 hover:bg-red-50 text-gray-400 hover:text-red-600 rounded-lg border transition-colors">
//                 <X className="w-4 h-4" />
//               </button>
//             </div>

//             {/* Form */}
//             <form onSubmit={handleCompOffSubmit} className="flex flex-col flex-1 overflow-hidden">
//               <div className="p-4 sm:p-6 space-y-4 overflow-y-auto flex-1 custom-scrollbar text-xs">
//                 {/* Worked Date */}
//                 <div>
//                   <label className="block text-[10px] text-gray-400 font-bold uppercase mb-1">Worked Date</label>
//                   <input
//                     type="date"
//                     value={compOffForm.workedDate}
//                     onChange={(e) => setCompOffForm(prev => ({ ...prev, workedDate: e.target.value }))}
//                     className="w-full border rounded-lg px-3 py-2 border-slate-200 text-slate-700 font-medium focus:outline-none focus:ring-1 focus:ring-red-200"
//                   />
//                   {compOffErrors.workedDate && (
//                     <p className="text-red-500 text-[10px] font-bold mt-1 flex items-center gap-1">
//                       <AlertCircle className="w-3.5 h-3.5" /> {compOffErrors.workedDate}
//                     </p>
//                   )}
//                 </div>

//                 {/* Reason */}
//                 <div>
//                   <label className="block text-[10px] text-gray-400 font-bold uppercase mb-1">Work Description / Reason</label>
//                   <textarea
//                     rows={3}
//                     placeholder="e.g. Worked on Sunday for new product release..."
//                     value={compOffForm.reason}
//                     onChange={(e) => setCompOffForm(prev => ({ ...prev, reason: e.target.value }))}
//                     className="w-full border rounded-lg px-3 py-2 border-slate-200 text-slate-700 font-medium focus:outline-none focus:ring-1 focus:ring-red-200"
//                   />
//                   {compOffErrors.reason && (
//                     <p className="text-red-500 text-[10px] font-bold mt-1 flex items-center gap-1">
//                       <AlertCircle className="w-3.5 h-3.5" /> {compOffErrors.reason}
//                     </p>
//                   )}
//                 </div>
//               </div>

//               {/* Footer */}
//               <div className="p-3 sm:p-4 border-t bg-slate-50 flex justify-end gap-2 shrink-0">
//                 <button type="button" onClick={() => setShowCompOffModal(false)} className="px-4 py-2 bg-white text-slate-700 border rounded-lg text-xs font-bold uppercase hover:bg-slate-50 transition-colors">
//                   Cancel
//                 </button>
//                 <button type="submit" disabled={submitting} className="px-4 py-2 bg-primary hover:bg-secondary text-white rounded-lg text-xs font-bold uppercase transition-colors disabled:opacity-50">
//                   {submitting ? "Submitting..." : "Request Grant"}
//                 </button>
//               </div>
//             </form>
//           </div>
//         </div>
//       )}

//     </div>
//   );
// }


import React, { useState, useEffect, useCallback } from "react";
import { toast } from "react-toastify";
import { 
  Calendar, Clock, X, Plus, AlertCircle, Award,
  CheckCircle2
} from "lucide-react";
import api from "../../common/apiClient";
import SummaryApi from "../../common/SummaryApi";
import PageLoader from "../../helpers/PageLoader";

export default function MyPermissionsAndCompOffs() {
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveStageTab] = useState("permissions");

  // Lists Data
  const [permissions, setPermissions] = useState([]);
  const [compOffs, setCompOffs] = useState([]);

  // Permission Stats (புதிதாக சேர்க்கப்பட்ட பேலன்ஸ் ஸ்டேட்)
  const [permStats, setPermStats] = useState({
    maxMinutes: 240,
    usedMinutes: 0,
    remainingMinutes: 240,
    maxCount: 4,
    usedCount: 0,
    remainingCount: 4
  });

  // Modal Open States
  const [showPermissionModal, setShowPermissionModal] = useState(false);
  const [showCompOffModal, setShowCompOffModal] = useState(false);

  // Form Submission Loader
  const [submitting, setSubmitting] = useState(false);

  // Form States
  const [permissionForm, setPermissionForm] = useState({
    date: "",
    startTime: "",
    endTime: "",
    reason: ""
  });

  const [compOffForm, setCompOffForm] = useState({
    workedDate: "",
    reason: ""
  });

  // Inline Validation Errors States
  const [permissionErrors, setPermissionErrors] = useState({});
  const [compOffErrors, setCompOffErrors] = useState({});

  // ── DATA FETCHING ─────────────────────────────────────────────────────────
  const fetchMyData = useCallback(async () => {
    setLoading(true);
    try {
      const permUrl = SummaryApi.myPermissions?.url || "/api/hr/permission/my";
      const compUrl = SummaryApi.myCompOffs?.url || "/api/hr/compoff/my";

      const [permRes, compRes] = await Promise.all([
        api.get(permUrl),
        api.get(compUrl)
      ]);

      if (permRes.data.success) {
        // Backend-இல் இருந்து வரும் புதிய { requests, stats } அமைப்பைப் பெறுகிறோம்
        setPermissions(permRes.data.data.requests || []);
        if (permRes.data.data.stats) {
          setPermStats(permRes.data.data.stats);
        }
      }
      if (compRes.data.success) {
        setCompOffs(compRes.data.data || []);
      }

    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to load request records.");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchMyData();
  }, [fetchMyData]);

  // நிமிடங்கள் என்பதை மணிநேரமாக மாற்றும் எளிய ஹெல்பர் (e.g., 120 -> 2.0 hrs)
  const formatMinutesToHours = (mins) => {
    return (mins / 60).toFixed(1);
  };

  // ── FRONTEND VALIDATIONS ─────────────────────────────────────────────────
  const validatePermissionForm = () => {
    const errors = {};
    if (!permissionForm.date) {
      errors.date = "Permission date is required.";
    }
    if (!permissionForm.startTime) {
      errors.startTime = "Start time is required.";
    }
    if (!permissionForm.endTime) {
      errors.endTime = "End time is required.";
    }

    if (permissionForm.startTime && permissionForm.endTime) {
      const [startH, startM] = permissionForm.startTime.split(':').map(Number);
      const [endH, endM] = permissionForm.endTime.split(':').map(Number);
      const startTotal = startH * 60 + startM;
      const endTotal = endH * 60 + endM;

      if (endTotal <= startTotal) {
        errors.endTime = "End time must be after the start time.";
      } else if (endTotal - startTotal > 120) {
        errors.endTime = "A single permission duration cannot exceed 2 hours (120 mins).";
      }
    }

    if (!permissionForm.reason || permissionForm.reason.trim().length < 5) {
      errors.reason = "Please provide a valid reason (at least 5 characters).";
    }

    setPermissionErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const validateCompOffForm = () => {
    const errors = {};
    if (!compOffForm.workedDate) {
      errors.workedDate = "Worked date is required.";
    } else {
      const selectedDate = new Date(compOffForm.workedDate);
      const today = new Date();
      today.setHours(23, 59, 59, 999);

      if (selectedDate > today) {
        errors.workedDate = "Worked date cannot be a future date.";
      }
    }

    if (!compOffForm.reason || compOffForm.reason.trim().length < 10) {
      errors.reason = "Please describe the work done in detail (at least 10 characters).";
    }

    setCompOffErrors(errors);
    return Object.keys(errors).length === 0;
  };

  // ── FORM SUBMISSIONS ──────────────────────────────────────────────────────
  const handlePermissionSubmit = async (e) => {
    e.preventDefault();
    if (!validatePermissionForm()) return;

    setSubmitting(true);
    try {
      const url = SummaryApi.requestPermission?.url || "/api/hr/permission/create";
      const res = await api.post(url, permissionForm);

      if (res.data.success) {
        toast.success(res.data.message || "Permission request submitted.");
        setShowPermissionModal(false);
        setPermissionForm({ date: "", startTime: "", endTime: "", reason: "" });
        setPermissionErrors({});
        fetchMyData();
      }
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to request permission.");
    } finally {
      setSubmitting(false);
    }
  };

  const handleCompOffSubmit = async (e) => {
    e.preventDefault();
    if (!validateCompOffForm()) return;

    setSubmitting(true);
    try {
      const url = SummaryApi.requestCompOff?.url || "/api/hr/compoff/create";
      const res = await api.post(url, compOffForm);

      if (res.data.success) {
        toast.success(res.data.message || "Comp-off earning request submitted.");
        setShowCompOffModal(false);
        setCompOffForm({ workedDate: "", reason: "" });
        setCompOffErrors({});
        fetchMyData();
      }
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to request Comp-off grant.");
    } finally {
      setSubmitting(false);
    }
  };

  if (loading) return <PageLoader />;

  return (
    <>
    <div className="space-y-6 animate-in fade-in duration-300">
      
      {/* HEADER WITH ACTION BUTTONS */}
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 bg-white border p-6 rounded-xl shadow-sm">
        <div>
          <h1 className="text-xl font-bold text-slate-900 tracking-tight">Permissions & Comp-offs</h1>
          <p className="text-xs text-slate-400 mt-1">Submit or track your short permissions and compensatory off grant requests.</p>
        </div>
        <div className="flex flex-wrap gap-2 shrink-0">
          <button
            onClick={() => {
              setPermissionErrors({});
              setShowPermissionModal(true);
            }}
            className="inline-flex items-center gap-1.5 bg-primary hover:bg-secondary text-white text-xs font-bold px-4 py-2 rounded-lg transition-all shadow-sm"
          >
            <Plus className="w-4 h-4" />
            <span>Apply Permission</span>
          </button>
          <button
            onClick={() => {
              setCompOffErrors({});
              setShowCompOffModal(true);
            }}
            className="inline-flex items-center gap-1.5 bg-secondary hover:bg-primary text-white text-xs font-bold px-4 py-2 rounded-lg transition-all shadow-sm"
          >
            <Plus className="w-4 h-4" />
            <span>Apply Comp-off</span>
          </button>
        </div>
      </div>

      {/* 👈 DYNAMIC PERMISSION STATS CARDS ROW (புதிதாக சேர்க்கப்பட்டது) */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {/* Allocated Hours */}
        <div className="bg-white border rounded-xl p-4 shadow-sm flex items-center gap-4">
          <div className="h-10 w-10 rounded-lg bg-blue-50 text-blue-600 flex items-center justify-center shrink-0 border border-blue-100">
            <Calendar className="w-5 h-5" />
          </div>
          <div>
            <span className="block text-[10px] text-slate-400 font-bold uppercase tracking-wider">Monthly Limit</span>
            <p className="text-lg font-bold text-slate-900 mt-0.5">{formatMinutesToHours(permStats.maxMinutes)} Hours</p>
            <span className="text-[10px] text-slate-400 font-medium">allocated per month</span>
          </div>
        </div>

        {/* Used Hours */}
        <div className="bg-white border rounded-xl p-4 shadow-sm flex items-center gap-4">
          <div className="h-10 w-10 rounded-lg bg-red-50 text-red-600 flex items-center justify-center shrink-0 border border-red-100">
            <Clock className="w-5 h-5" />
          </div>
          <div>
            <span className="block text-[10px] text-slate-400 font-bold uppercase tracking-wider">Used Duration</span>
            <p className="text-lg font-bold text-red-600 mt-0.5">{formatMinutesToHours(permStats.usedMinutes)} Hours</p>
            <span className="text-[10px] text-red-500 font-semibold">{permStats.usedMinutes} mins spent</span>
          </div>
        </div>

        {/* Remaining Hours */}
        <div className="bg-white border rounded-xl p-4 shadow-sm flex items-center gap-4">
          <div className="h-10 w-10 rounded-lg bg-green-50 text-green-600 flex items-center justify-center shrink-0 border border-green-100">
            <CheckCircle2 className="w-5 h-5" />
          </div>
          <div>
            <span className="block text-[10px] text-slate-400 font-bold uppercase tracking-wider">Remaining Balance</span>
            <p className="text-lg font-bold text-green-600 mt-0.5">{formatMinutesToHours(permStats.remainingMinutes)} Hours</p>
            <span className="text-[10px] text-green-600 font-semibold">{permStats.remainingMinutes} mins left</span>
          </div>
        </div>

        {/* Allowed Count/Frequency */}
        <div className="bg-white border rounded-xl p-4 shadow-sm flex items-center gap-4">
          <div className="h-10 w-10 rounded-lg bg-amber-50 text-amber-600 flex items-center justify-center shrink-0 border border-amber-100">
            <Award className="w-5 h-5" />
          </div>
          <div>
            <span className="block text-[10px] text-slate-400 font-bold uppercase tracking-wider">Permissions Count</span>
            <p className="text-lg font-bold text-slate-900 mt-0.5">
              {permStats.usedCount} / {permStats.maxCount > 0 ? `${permStats.maxCount} Times` : "No Limit"}
            </p>
            <span className="text-[10px] text-slate-400 font-medium">taken in this month</span>
          </div>
        </div>
      </div>

      {/* TABS CONTAINER */}
      <div className="overflow-hidden flex flex-col">
        {/* Navigation Tabs */}
        <div className="flex border-b">
          <button
            onClick={() => setActiveStageTab("permissions")}
            className={`flex-1 py-4 text-center text-xs font-bold uppercase tracking-wider border-b-2 transition-all ${
              activeTab === "permissions" 
                ? "border-red-600 text-red-600 bg-red-50/10" 
                : "border-transparent text-slate-500 hover:text-secondary hover:bg-slate-50/50"
            }`}
          >
            Hourly Permissions ({permissions.length})
          </button>
          <button
            onClick={() => setActiveStageTab("compoffs")}
            className={`flex-1 py-4 text-center text-xs font-bold uppercase tracking-wider border-b-2 transition-all ${
              activeTab === "compoffs" 
                ? "border-red-600 text-red-600 bg-red-50/10" 
                : "border-transparent text-slate-500 hover:text-secondary hover:bg-slate-50/50"
            }`}
          >
            Comp-off Grants ({compOffs.length})
          </button>
        </div>

        {/* LIST TABLE CONTENT */}
        <div className="p-4 sm:p-6 overflow-x-auto">
          {activeTab === "permissions" ? (
            permissions.length === 0 ? (
              <div className="text-center py-16 text-slate-400 text-xs font-medium">
                No hourly permission requests submitted yet.
              </div>
            ) : (
              <table className="w-full text-left border-collapse text-xs">
                <thead>
                  <tr className="bg-slate-50 border-b text-[10px] font-bold text-slate-400 uppercase tracking-wider">
                    <th className="py-3 px-4">Requested Date</th>
                    <th className="py-3 px-4">Time Interval</th>
                    <th className="py-3 px-4">Duration</th>
                    <th className="py-3 px-4">Reason</th>
                    <th className="py-3 px-4">Status</th>
                    <th className="py-3 px-4">Approver Note</th>
                  </tr>
                </thead>
                <tbody className="divide-y text-slate-700">
                  {permissions.map((p) => (
                    <tr key={p._id} className="hover:bg-slate-50/40 transition-colors">
                      <td className="py-3 px-4 font-bold text-slate-900">{new Date(p.date).toLocaleDateString()}</td>
                      <td className="py-3 px-4 font-semibold text-slate-600">{p.startTime} - {p.endTime}</td>
                      <td className="py-3 px-4 font-medium text-slate-500">{p.durationMinutes} Minutes</td>
                      <td className="py-3 px-4 italic max-w-xs truncate">"{p.reason || "N/A"}"</td>
                      <td className="py-3 px-4">
                        <span className={`text-[9px] font-bold px-2 py-0.5 rounded-full border uppercase tracking-wider ${
                          p.status === "approved" 
                            ? "bg-green-50 text-green-700 border-green-200" 
                            : p.status === "pending"
                            ? "bg-amber-50 text-amber-700 border-amber-200"
                            : "bg-red-50 text-red-700 border-red-200"
                        }`}>
                          {p.status}
                        </span>
                      </td>
                      <td className="py-3 px-4 text-slate-400 italic">
                        {p.approverNote ? `"${p.approverNote}"` : "-"}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )
          ) : (
            compOffs.length === 0 ? (
              <div className="text-center py-16 text-slate-400 text-xs font-medium">
                No compensatory off requests submitted yet.
              </div>
            ) : (
              <table className="w-full text-left border-collapse text-xs">
                <thead>
                  <tr className="bg-slate-50 border-b text-[10px] font-bold text-slate-400 uppercase tracking-wider">
                    <th className="py-3 px-4">Worked Date</th>
                    <th className="py-3 px-4">Earning Reason</th>
                    <th className="py-3 px-4">Expiry Date</th>
                    <th className="py-3 px-4">Status</th>
                    <th className="py-3 px-4">Approver Note</th>
                  </tr>
                </thead>
                <tbody className="divide-y text-slate-700">
                  {compOffs.map((c) => (
                    <tr key={c._id} className="hover:bg-slate-50/40 transition-colors">
                      <td className="py-3 px-4 font-bold text-slate-900">{new Date(c.workedDate).toLocaleDateString()}</td>
                      <td className="py-3 px-4 font-medium text-slate-600">"{c.reason}"</td>
                      <td className="py-3 px-4 text-slate-500 font-semibold">
                        {c.expiryDate ? new Date(c.expiryDate).toLocaleDateString() : "Pending approval"}
                      </td>
                      <td className="py-3 px-4">
                        <span className={`text-[9px] font-bold px-2 py-0.5 rounded-full border uppercase tracking-wider ${
                          c.status === "approved" 
                            ? "bg-green-50 text-green-700 border-green-200" 
                            : c.status === "pending"
                            ? "bg-amber-50 text-amber-700 border-amber-200"
                            : "bg-red-50 text-red-700 border-red-200"
                        }`}>
                          {c.status}
                        </span>
                      </td>
                      <td className="py-3 px-4 text-slate-400 italic">
                        {c.approverNote ? `"${c.approverNote}"` : "-"}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )
          )}
        </div>
      </div>
    </div>
          {/* APPLIED PERMISSION MODAL */}
      {showPermissionModal && (
        <div className="fixed inset-0 top-[57px] md:top-[65px] z-[65] flex items-center justify-center p-3 sm:p-4 bg-black/50 backdrop-blur-sm animate-in fade-in duration-200">
          <div className="bg-white w-full max-w-md rounded-xl shadow-xl border flex flex-col max-h-[90vh] sm:max-h-[85vh] overflow-hidden animate-in fade-in zoom-in-95 duration-200">
            {/* Header */}
            <div className="p-4 sm:p-5 border-b flex justify-between items-center shrink-0">
              <div className="flex gap-3 items-center">
                <div className="w-10 h-10 rounded-full bg-red-50 text-primary flex items-center justify-center shrink-0 border border-red-100">
                  <Clock className="w-5 h-5" />
                </div>
                <div>
                  <h3 className="font-bold text-gray-900 text-sm sm:text-base leading-tight">Request Hourly Permission</h3>
                  <p className="text-[10px] text-gray-400 font-bold uppercase mt-0.5">Short Duration Approval Request</p>
                </div>
              </div>
              <button onClick={() => setShowPermissionModal(false)} className="p-1.5 hover:bg-red-50 text-gray-400 hover:text-red-600 rounded-lg border transition-colors">
                <X className="w-4 h-4" />
              </button>
            </div>

            {/* Form */}
            <form onSubmit={handlePermissionSubmit} className="flex flex-col flex-1 overflow-hidden">
              <div className="p-4 sm:p-6 space-y-4 overflow-y-auto flex-1 custom-scrollbar text-xs">
                {/* Date */}
                <div>
                  <label className="block text-[10px] text-gray-400 font-bold uppercase mb-1">Permission Date</label>
                  <input
                    type="date"
                    value={permissionForm.date}
                    onChange={(e) => setPermissionForm(prev => ({ ...prev, date: e.target.value }))}
                    className="w-full border rounded-lg px-3 py-2 border-slate-200 text-slate-700 font-medium focus:outline-none focus:ring-1 focus:ring-red-200"
                  />
                  {permissionErrors.date && (
                    <p className="text-red-500 text-[10px] font-bold mt-1 flex items-center gap-1">
                      <AlertCircle className="w-3.5 h-3.5" /> {permissionErrors.date}
                    </p>
                  )}
                </div>

                {/* Times */}
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-[10px] text-gray-400 font-bold uppercase mb-1">Start Time</label>
                    <input
                      type="time"
                      value={permissionForm.startTime}
                      onChange={(e) => setPermissionForm(prev => ({ ...prev, startTime: e.target.value }))}
                      className="w-full border rounded-lg px-3 py-2 border-slate-200 text-slate-700 font-medium focus:outline-none focus:ring-1 focus:ring-red-200"
                    />
                    {permissionErrors.startTime && (
                      <p className="text-red-500 text-[10px] font-bold mt-1 flex items-center gap-1">
                        <AlertCircle className="w-3.5 h-3.5" /> {permissionErrors.startTime}
                      </p>
                    )}
                  </div>
                  <div>
                    <label className="block text-[10px] text-gray-400 font-bold uppercase mb-1">End Time</label>
                    <input
                      type="time"
                      value={permissionForm.endTime}
                      onChange={(e) => setPermissionForm(prev => ({ ...prev, endTime: e.target.value }))}
                      className="w-full border rounded-lg px-3 py-2 border-slate-200 text-slate-700 font-medium focus:outline-none focus:ring-1 focus:ring-red-200"
                    />
                    {permissionErrors.endTime && (
                      <p className="text-red-500 text-[10px] font-bold mt-1 flex items-center gap-1">
                        <AlertCircle className="w-3.5 h-3.5" /> {permissionErrors.endTime}
                      </p>
                    )}
                  </div>
                </div>

                {/* Reason */}
                <div>
                  <label className="block text-[10px] text-gray-400 font-bold uppercase mb-1">Reason</label>
                  <textarea
                    rows={3}
                    placeholder="Provide a valid reason for this permission request..."
                    value={permissionForm.reason}
                    onChange={(e) => setPermissionForm(prev => ({ ...prev, reason: e.target.value }))}
                    className="w-full border rounded-lg px-3 py-2 border-slate-200 text-slate-700 font-medium focus:outline-none focus:ring-1 focus:ring-red-200"
                  />
                  {permissionErrors.reason && (
                    <p className="text-red-500 text-[10px] font-bold mt-1 flex items-center gap-1">
                      <AlertCircle className="w-3.5 h-3.5" /> {permissionErrors.reason}
                    </p>
                  )}
                </div>
              </div>

              {/* Footer */}
              <div className="p-3 sm:p-4 border-t bg-slate-50 flex justify-end gap-2 shrink-0">
                <button type="button" onClick={() => setShowPermissionModal(false)} className="px-4 py-2 bg-white text-slate-700 border rounded-lg text-xs font-bold uppercase hover:bg-slate-50 transition-colors">
                  Cancel
                </button>
                <button type="submit" disabled={submitting} className="px-4 py-2 bg-primary hover:bg-secondary text-white rounded-lg text-xs font-bold uppercase transition-colors disabled:opacity-50">
                  {submitting ? "Submitting..." : "Submit Request"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* COMP-OFF REQUEST MODAL */}
      {showCompOffModal && (
        <div className="fixed inset-0 top-[57px] md:top-[65px] z-[65] flex items-center justify-center p-3 sm:p-4 bg-black/50 backdrop-blur-sm animate-in fade-in duration-200">
          <div className="bg-white w-full max-w-md rounded-xl shadow-xl border flex flex-col max-h-[90vh] sm:max-h-[85vh] overflow-hidden animate-in fade-in zoom-in-95 duration-200">
            {/* Header */}
            <div className="p-4 sm:p-5 border-b flex justify-between items-center shrink-0">
              <div className="flex gap-3 items-center">
                <div className="w-10 h-10 rounded-full bg-slate-50 text-slate-700 flex items-center justify-center shrink-0 border border-slate-100">
                  <Calendar className="w-5 h-5" />
                </div>
                <div>
                  <h3 className="font-bold text-gray-900 text-sm sm:text-base leading-tight">Request Comp-off Grant</h3>
                  <p className="text-[10px] text-gray-400 font-bold uppercase mt-0.5">Credit Comp-off Day For Holiday Worked</p>
                </div>
              </div>
              <button onClick={() => setShowCompOffModal(false)} className="p-1.5 hover:bg-red-50 text-gray-400 hover:text-red-600 rounded-lg border transition-colors">
                <X className="w-4 h-4" />
              </button>
            </div>

            {/* Form */}
            <form onSubmit={handleCompOffSubmit} className="flex flex-col flex-1 overflow-hidden">
              <div className="p-4 sm:p-6 space-y-4 overflow-y-auto flex-1 custom-scrollbar text-xs">
                {/* Worked Date */}
                <div>
                  <label className="block text-[10px] text-gray-400 font-bold uppercase mb-1">Worked Date</label>
                  <input
                    type="date"
                    value={compOffForm.workedDate}
                    onChange={(e) => setCompOffForm(prev => ({ ...prev, workedDate: e.target.value }))}
                    className="w-full border rounded-lg px-3 py-2 border-slate-200 text-slate-700 font-medium focus:outline-none focus:ring-1 focus:ring-red-200"
                  />
                  {compOffErrors.workedDate && (
                    <p className="text-red-500 text-[10px] font-bold mt-1 flex items-center gap-1">
                      <AlertCircle className="w-3.5 h-3.5" /> {compOffErrors.workedDate}
                    </p>
                  )}
                </div>

                {/* Reason */}
                <div>
                  <label className="block text-[10px] text-gray-400 font-bold uppercase mb-1">Work Description / Reason</label>
                  <textarea
                    rows={3}
                    placeholder="e.g. Worked on Sunday for new product release..."
                    value={compOffForm.reason}
                    onChange={(e) => setCompOffForm(prev => ({ ...prev, reason: e.target.value }))}
                    className="w-full border rounded-lg px-3 py-2 border-slate-200 text-slate-700 font-medium focus:outline-none focus:ring-1 focus:ring-red-200"
                  />
                  {compOffErrors.reason && (
                    <p className="text-red-500 text-[10px] font-bold mt-1 flex items-center gap-1">
                      <AlertCircle className="w-3.5 h-3.5" /> {compOffErrors.reason}
                    </p>
                  )}
                </div>
              </div>

              {/* Footer */}
              <div className="p-3 sm:p-4 border-t bg-slate-50 flex justify-end gap-2 shrink-0">
                <button type="button" onClick={() => setShowCompOffModal(false)} className="px-4 py-2 bg-white text-slate-700 border rounded-lg text-xs font-bold uppercase hover:bg-slate-50 transition-colors">
                  Cancel
                </button>
                <button type="submit" disabled={submitting} className="px-4 py-2 bg-primary hover:bg-secondary text-white rounded-lg text-xs font-bold uppercase transition-colors disabled:opacity-50">
                  {submitting ? "Submitting..." : "Request Grant"}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
}